import { Injectable } from '@angular/core';
import {FileDownloader} from "../types/file-downloader";
import {UrlBuilderService} from "@feature/common";
import { HttpClient } from '@angular/common/http';
import {NoticeboardFileDownloadService} from "./noticeboard-file-download.service";

/**
 * Factory service for creating instances of objects which implement `FileDownloader`.
 */
@Injectable({ providedIn:'root'})
export class FileDownloaderFactoryService {

    /**
     * Gets an instance of `FileDownloader` which is suitable for use to download noticeboard attached files.
     * @param uri The uri of the file in document centre; this is used to build the HTTP request for the file.
     */
    getNoticeboardAttachmentDownloader(uri : number) : FileDownloader {
        return new NoticeboardFileDownloadService(this.urlBuilder, this.http, uri);
    }

    constructor(private readonly urlBuilder : UrlBuilderService,
                private readonly http : HttpClient) {}
}
